import {
    UseActions
} from "@Store/@Hooks/@@Actions";


export const UseUserSignInAction = () => {
    return UseActions().UserSignInAction;
};


export const UseUserSignOutAction = () => {
    return UseActions().UserSignOutAction;
};
